import {apiMiddleware} from './api-reducers.ts';
import {configureStore} from '@reduxjs/toolkit';
import {listenerMiddleware} from './middlewares/listeners.ts';
import rootReducer from './root-reducer.ts';

import constants from '@/config/constant.ts';
import {PROFILE} from '@/config/types';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: constants.APP_PROFILE === PROFILE.DEV,
    })
      .prepend(listenerMiddleware.middleware)
      .concat(apiMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
